import { withStyles } from '@material-ui/core/styles';
import FiltersCallToAction from './FiltersCallToAction';
import styles from './FiltersCallToAction.styles';

export default withStyles(styles)(FiltersCallToAction);
